import { gql } from 'apollo-angular';

export const ADD_PHASE = gql`
  mutation CreatePhase($input: CreatePhaseInput!) {
    createPhase(input: $input) {
      id
      tenantId
      name
      bucket {
        start
        finish
      }
    }
  }
`;

export const GET_PHASES = gql`
  query SearchPhases($criteria: SearchPhasesCriteria!) {
    phases(criteria: $criteria) {
      id
      tenantId
      name
      bucket {
        start
        finish
      }
    }
  }
`;

export const UPDATE_PHASE = gql`
  mutation UpdatePhase($input: UpdatePhaseInput!) {
    updatePhase(input: $input) {
      id
      tenantId
      name
      bucket {
        start
        finish
      }
    }
  }
`;

export const DELETE_PHASE = gql`
  mutation DeletePhase($id: ID!) {
    deletePhase(id: $id) {
      id
    }
  }
`;
